var _path, _path2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorEscalator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32.14,17.354h0c0-1.777-1.441-3.218-3.218-3.218h-2.972c-.431,0-.844.171-1.149.476l-9.919,9.919c-.197.197-.465.308-.744.308h-1.06c-1.777,0-3.218,1.441-3.218,3.218h0c0,1.777,1.441,3.218,3.218,3.218h2.731c.431,0,.844-.171,1.149-.476l9.92-9.92c.197-.197.465-.308.744-.308h1.299c1.777,0,3.218-1.441,3.218-3.218Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.715,20.255v-2.445c0-.999.809-1.808,1.808-1.808h0c.749,0,1.391.455,1.666,1.104"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.523,
    cy: 12.532,
    r: 1.808
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 18.549
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorEscalator);
export default __webpack_public_path__ + "static/media/indoor-escalator.56752b3e2b90e7273c923d90323c668c.svg";
export { ForwardRef as ReactComponent };